
import Eraser1 from "../../../assets/outline/Eraser1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Eraser1Icon({ className, dataTestid = "Eraser1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Eraser1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
